const PRICE_NEGOTIATION_PERMISSIONS_NAMES = {
  // ticket related
  TICKET_EDITION: 'TICKET_EDITION',
  TICKET_CANCELLATION: 'TICKET_CANCELLATION',
  // quote related
  QUOTE_CREATION: 'QUOTE_CREATION',
  QUOTE_EDITION: 'QUOTE_EDITION',
  QUOTE_ACCEPTANCE: 'QUOTE_ACCEPTANCE',
  QUOTE_REJECTION: 'QUOTE_REJECTION',
  // actions related
  // empty actions
  ACTION_SEND_MESSAGE: 'ACTION_SEND_MESSAGE',
  ACTION_FINISH_COST_NEGOTIATION: 'ACTION_FINISH_COST_NEGOTIATION',
  ACTION_CLOSE_AUCTIONS: 'ACTION_CLOSE_AUCTIONS',
  ACTION_LAUNCH_OFFER: 'ACTION_LAUNCH_OFFER',
  // withouth the +
  // no tooltip for no agent
  ACTION_ASSIGN_TO_AGENT: 'ACTION_ASSIGN_TO_AGENT',
};

export default PRICE_NEGOTIATION_PERMISSIONS_NAMES;
